export const checkIsFirefox = () => {
  return /firefox/i.test(navigator.userAgent)
}
